import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import {forceScrollSmootherUpdate} from '../utility/gsap';

const initializeBlock = function( $block ){
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  const slider = $block.querySelector('.slider_block__slider');

  const isAdmin = document.body.classList.contains('wp-admin');
  let args = {
    gap: '3rem',
    drag: isAdmin ? false : true,
    noDrag: isAdmin ? '.splide, .splide__slide, figure, img, picture, .card, .media_block' : '',
  };

  if(slider.splide){
    // If the slider already exists, destroy it first
    slider.splide.destroy();
    slider.splide = null;
  }

  // For slides that don't already have the .splide__slide class, add it
  const slides = slider.querySelectorAll('.quiz_card, .splide__list > .card');
  Array.prototype.forEach.call(slides, function(el, i){
    if(!el.classList.contains('splide__slide')){
      el.classList.add('splide__slide');
    }
  });

  const slideCount = $block.querySelectorAll('.splide__slide').length;

  const isImageSlider = $block.classList.contains('slider-type-image') || $block.querySelector('.slider-type-image');
  const isQuizSlider = $block.classList.contains('slider-type-quiz') || $block.querySelector('.slider-type-quiz');
  const isCardSlider = $block.classList.contains('slider-type-cards') || $block.querySelector('.slider-type-cards');

  // Image Slider Args
  if(isImageSlider){
    args.pagination = true;
    args.arrows = false;
    args.rewind = true;
    args.rewindByDrag = true;
    args.drag = slideCount > 1;
    args.autoplay = true;
    args.interval = 5000;
  }

  // Quiz Card Slider Args
  else if(isQuizSlider){
    args.pagination = true;
    args.arrows = true;
    args.drag = slideCount > 1;
    args.breakpoints = {
      1320: {
          arrows: false,
        },
    };
  }
  
  // Card Slider Args
  else if(isCardSlider){
    args = {
      gap: '3rem',
      perPage: 3,
      pagination: false,
      speed: 600,
      autoHeight: true,
      rewind: true,
      drag : slideCount > 3,
      breakpoints: {
        990: {
          gap: '2rem',
          perPage: 2,
          padding: { right: '4rem' },
          drag : slideCount > 2,
        },
        767: {
          gap: '1.6rem',
          arrows : false
        },
        500: {
          perPage: 1,
          drag : slideCount > 1,
        }
      }
    }
  }

  if(slider){
    // Create the slider
    slider.splide = new Splide(slider, args); 
    
    let currentSlideIndex = 0;

    // Update navigation count / progess bar
    const navWrap = slider.querySelector('.splide__arrows');
    const leftArrow = slider.querySelector('.splide__arrow--prev');
    const rightArrow = slider.querySelector('.splide__arrow--next');
    
    if(!!navWrap){

      slider.splide.on('move', (newIndex) => {
        currentSlideIndex = newIndex;
        
        if(args.rewind || args.rewindByDrag){ return; }

        if(newIndex == 0 && !!leftArrow){
          leftArrow.disabled = true;
        }
        else if(!!leftArrow && leftArrow.disabled){
          leftArrow.disabled = false;
        }
        
        if(newIndex > (slider.splide.length - 1 - slider.splide.options.perPage) && !!rightArrow){
          rightArrow.disabled = true;
        }
        else if(!!rightArrow && rightArrow.disabled){
          rightArrow.disabled = false;
        }
      });

      slider.splide.on( 'move mounted resized', () => {
        let current = currentSlideIndex + 1;
        const {Slides} = slider.splide.Components;
  
        // Progress bar
        const lastVisibleSlide = current + (slider.splide.options.perPage - 1);
        const progressBar = slider.querySelector('.progress');
        if(progressBar){
          let progress = Math.round(lastVisibleSlide / Slides.getLength() * 100);
          
          // Ensure resize events don't trip things up. 
          if(progress > 100){
            progress = 100;
          }
  
          progressBar.style.setProperty('--progress', progress + '%');
        }

        // Update scroll smoother
        forceScrollSmootherUpdate();
        window.dispatchEvent(new Event('resize'));
      } );
    }

    // Slide inner content animations
    slider.splide.on('move mounted', () => {
      if(isImageSlider){
        // toggle animated class on .td_animation elements
        const animEls = slider.querySelectorAll('.td_animation');
        Array.prototype.forEach.call(animEls, function(el, i){
          const slideIndex = slider.splide.index || 0;
          const currentSlideEl = slider.querySelectorAll('.splide__slide')[slideIndex];
          if(el.closest('.splide__slide') == currentSlideEl){
            el.classList.add('animated');
          }
          else if(el.classList.contains('animated')){
            el.classList.remove('animated');
          }
        });
      }
    });

    // Mount the slider
    slider.splide.mount();
  }

}


// Initialize the slider on the front end
export const initializeSlider = function(){
  const sliders = document.querySelectorAll('.slider_block');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
};

const maybeInitializeBlock = function( $block ){
  const slider = $block.closest('.slider_block__slider');
  if(!!slider){
    initializeBlock(slider.parentElement);
  }
}

export const initializeSliderEditor = function (){
  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    // window.acf.addAction( 'render_block_preview/type=slider', initializeBlock );
    // window.acf.addAction( 'render_block_preview/type=card', maybeInitializeBlock );
  }
}